import api from './api';
import { Project, ProjectMember } from '../types/project';

export const projectApi = {
  getAll: async (): Promise<Project[]> => {
    const r = await api.get('/projects');
    return r.data || [];
  },
  getById: async (id: string): Promise<Project> => {
    const r = await api.get(`/projects/${id}`);
    return r.data;
  },
  create: async (data: any): Promise<Project> => {
    const r = await api.post('/projects', data);
    return r.data;
  },
  update: async (id: string, data: any): Promise<Project> => {
    const r = await api.put(`/projects/${id}`, data);
    return r.data;
  },
  delete: async (id: string): Promise<void> => {
    await api.delete(`/projects/${id}`);
  },
  getMembers: async (projectId: string): Promise<ProjectMember[]> => {
    const r = await api.get(`/projects/${projectId}/members`);
    return r.data;
  },
  addMember: async (projectId: string, userId: string, role: string): Promise<ProjectMember> => {
    const r = await api.post(`/projects/${projectId}/members`, { userId, role });
    return r.data;
  },
  removeMember: async (projectId: string, userId: string): Promise<void> => {
    await api.delete(`/projects/${projectId}/members/${userId}`);
  },
};
